function ArrowUpIcon() {
  return (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.29289 0.594651C4.65338 0.234167 5.22061 0.206438 5.6129 0.511462L5.70711 0.594651L9.70711 4.59465C10.0976 4.98518 10.0976 5.61834 9.70711 6.00886C9.34662 6.36935 8.77939 6.39708 8.3871 6.09205L8.29289 6.00886L5 2.71676L1.70711 6.00886C1.34662 6.36935 0.779392 6.39708 0.387101 6.09205L0.292893 6.00886C-0.0675907 5.64838 -0.0953203 5.08115 0.209705 4.68886L0.292893 4.59465L4.29289 0.594651Z"
        fill="#ADB3BC"
      />
    </svg>
  );
}

function ArrowDownIcon() {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4234 0.594651C10.7839 0.955135 10.8116 1.52237 10.5066 1.91466L10.4234 2.00886L6.42342 6.00886C6.06293 6.36935 5.4957 6.39708 5.10341 6.09205L5.0092 6.00886L1.0092 2.00886C0.618678 1.61834 0.618678 0.985175 1.0092 0.594651C1.36969 0.234167 1.93692 0.206438 2.32921 0.511462L2.42342 0.594651L5.71631 3.88676L9.0092 0.594651C9.36969 0.234167 9.93692 0.206438 10.3292 0.511462L10.4234 0.594651Z"
        fill="#ADB3BC"
      />
    </svg>
  );
}
function EditIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.20229 0.390596C6.50513 0.101051 8.09379 0 10 0C11.9062 0 13.4949 0.101051 14.7977 0.390596C16.11 0.682244 17.1828 1.1761 18.0034 1.99663C18.8239 2.81716 19.3178 3.88999 19.6094 5.20229C19.8989 6.50513 20 8.09379 20 10C20 11.9062 19.8989 13.4949 19.6094 14.7977C19.3178 16.11 18.8239 17.1828 18.0034 18.0034C17.1828 18.8239 16.11 19.3178 14.7977 19.6094C13.4949 19.8989 11.9062 20 10 20C8.09379 20 6.50513 19.8989 5.20229 19.6094C3.88999 19.3178 2.81716 18.8239 1.99663 18.0034C1.1761 17.1828 0.682244 16.11 0.390596 14.7977C0.101051 13.4949 0 11.9062 0 10C0 8.09379 0.101051 6.50513 0.390596 5.20229C0.682244 3.88999 1.1761 2.81716 1.99663 1.99663C2.81716 1.1761 3.88999 0.682244 5.20229 0.390596ZM10.516 4.68026C11.1387 4.02735 12.1754 3.99309 12.841 4.59964L15.3001 6.84067C15.9765 7.45709 16.0154 8.50262 15.3826 9.16625L10.3173 14.4778C10.0041 14.8063 9.57021 14.9897 9.11982 14.9914L6.81347 15C5.95658 15.0032 5.21606 14.351 5.15648 13.4736L5.00372 11.224C4.97268 10.7668 5.13683 10.3211 5.45078 9.99186L10.516 4.68026ZM11.7194 5.83334L10.9684 6.62089L13.4048 8.82517L14.1481 8.04575L11.7204 5.83334L11.7194 5.83334ZM12.2542 10.0317L9.8178 7.82746L6.66788 11.1306L6.81746 13.3333L9.11363 13.3248L12.2542 10.0317Z"
        fill="#48BF91"
      />
    </svg>
  );
}

function DeleteIcon() {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66677 1.7252C3.61097 1.94483 1.50675 2.74414 0.383242 3.4654C-0.00405533 3.71404 -0.116463 4.22956 0.132172 4.61686C0.380807 5.00416 0.896332 5.11657 1.28363 4.86793C2.27396 4.23216 4.60824 3.33333 8.33344 3.33333C12.0463 3.33333 14.3174 4.22687 15.4037 4.88066C15.798 5.11799 16.3101 4.99071 16.5474 4.59639C16.7848 4.20206 16.6575 3.69 16.2632 3.45267C15.0904 2.74682 13.0449 1.94596 10.0001 1.72549V0.833333C10.0001 0.373096 9.62701 0 9.16677 0H7.5001C7.03986 0 6.66677 0.373096 6.66677 0.833333V1.7252Z"
        fill="#E64040"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.471109 13.1455C0.424936 12.9364 0.377447 12.7212 0.32825 12.5C-1.00593 6.5 1.74116 5 8.33343 5C14.9257 5 17.6728 6.5 16.3386 12.5C16.2904 12.7169 16.2438 12.928 16.1985 13.1333L16.1972 13.1391L16.1958 13.1451C14.9898 18.6081 14.6826 20 8.33343 20C1.98425 20 1.67709 18.6086 0.471109 13.1455ZM5.00009 9.16667C5.46033 9.16667 5.83343 9.53976 5.83343 10V15C5.83343 15.4602 5.46033 15.8333 5.00009 15.8333C4.53986 15.8333 4.16676 15.4602 4.16676 15V10C4.16676 9.53976 4.53986 9.16667 5.00009 9.16667ZM9.16676 10C9.16676 9.53976 8.79366 9.16667 8.33343 9.16667C7.87319 9.16667 7.50009 9.53976 7.50009 10V15C7.50009 15.4602 7.87319 15.8333 8.33343 15.8333C8.79366 15.8333 9.16676 15.4602 9.16676 15V10ZM11.6668 9.16667C12.127 9.16667 12.5001 9.53976 12.5001 10V15C12.5001 15.4602 12.127 15.8333 11.6668 15.8333C11.2065 15.8333 10.8334 15.4602 10.8334 15V10C10.8334 9.53976 11.2065 9.16667 11.6668 9.16667Z"
        fill="#E64040"
      />
    </svg>
  );
}

function CartIcon() {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 1L3.75333 1.39L4.79658 13.8191C4.88 14.8342 5.72825 15.6131 6.74658 15.6098H18.5647C19.5364 15.612 20.3608 14.897 20.4984 13.935L21.5265 6.8305C21.6413 6.03642 21.0899 5.29975 20.2969 5.18492C20.2276 5.17517 4.11517 5.16975 4.11517 5.16975"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.8228 9.17375H16.8268"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.27146 19.3652C6.59755 19.3652 6.8608 19.6296 6.8608 19.9546C6.8608 20.2807 6.59755 20.545 6.27146 20.545C5.94538 20.545 5.68213 20.2807 5.68213 19.9546C5.68213 19.6296 5.94538 19.3652 6.27146 19.3652Z"
        fill="white"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.4917 19.3652C18.8178 19.3652 19.0821 19.6296 19.0821 19.9546C19.0821 20.2807 18.8178 20.545 18.4917 20.545C18.1656 20.545 17.9023 20.2807 17.9023 19.9546C17.9023 19.6296 18.1656 19.3652 18.4917 19.3652Z"
        fill="white"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function MasterCardSvg() {
  return (
    <svg
      width="57"
      height="35"
      viewBox="0 0 57 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.1106 31.2549H20.7192V3.74193H36.1106V31.2549Z"
        fill="#FF5A00"
      />
      <path
        d="M21.7436 17.5C21.7436 23.0898 24.3848 28.051 28.4375 31.2565C25.4549 33.5898 21.6924 35 17.5884 35C7.86642 35 0 27.1731 0 17.5C0 7.82686 7.86642 6.33299e-07 17.5884 6.33299e-07C21.6924 6.33299e-07 25.4549 1.41019 28.4375 3.74353C24.3791 6.90372 21.7436 11.9102 21.7436 17.5Z"
        fill="#EB001B"
      />
      <path
        d="M56.875 17.5C56.875 7.82686 49.0086 6.33299e-07 39.2866 6.33299e-07C35.1826 6.33299e-07 31.4201 1.41019 28.4375 3.74353C32.5415 6.95469 35.1314 11.9102 35.1314 17.5C35.1314 23.0898 32.4902 28.051 28.4375 31.2565C31.4144 33.5898 35.1769 35 39.2809 35C49.0086 35 56.875 27.1222 56.875 17.5Z"
        fill="#F79E1B"
      />
    </svg>
  );
}

function VisaCardSvg() {
  return (
    <svg
      width="60"
      height="18"
      viewBox="0 0 60 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.0517 0.926197C36.6593 0.219633 38.4313 -0.0351933 40.168 0.0111387C41.5058 0.0806368 42.8436 0.277548 44.0875 0.775618C43.841 2.015 43.5946 3.25438 43.313 4.48218C41.7522 3.76404 39.992 3.50921 38.2787 3.70612C37.6333 3.81037 36.9175 4.06519 36.5772 4.66751C36.319 5.154 36.5537 5.74473 36.9996 6.03431C38.4313 7.08836 40.2502 7.51693 41.6232 8.65207C42.4329 9.30071 43.0783 10.1926 43.266 11.2119C43.4773 12.3934 43.2191 13.6443 42.5971 14.6637C42.3859 15.0227 42.1043 15.3123 41.8579 15.6482C40.8487 14.6521 39.8043 13.6907 38.8068 12.6945C38.6073 12.486 38.3844 12.3239 38.1614 12.1386C37.5864 11.2814 36.5772 10.8876 35.6736 10.4474C34.9695 10.1115 34.2537 9.76404 33.62 9.30072L33.7726 9.27755C33.3384 8.73315 32.869 8.20033 32.646 7.52851C31.9537 5.57099 32.4583 3.19647 34.0425 1.79492C34.3476 1.49376 34.7935 1.32002 35.0282 0.949363L35.0517 0.926197Z"
        fill="#3C58BF"
      />
      <path
        d="M25.8516 0.578414C27.1659 0.543665 28.4802 0.578414 29.7827 0.566831C28.9848 5.28112 28.1399 9.9954 27.3302 14.7097C27.1541 15.6595 27.0133 16.6325 26.8138 17.5823C25.1827 17.5591 23.5398 17.6286 21.9204 17.5475C23.5281 17.4896 25.124 17.5707 26.7317 17.5012C26.6143 17.3622 26.497 17.2116 26.3796 17.0842C25.2062 15.9143 24.0561 14.7329 22.8827 13.563C23.8567 9.23092 24.8776 4.91046 25.8516 0.578414Z"
        fill="#3C58BF"
      />
      <path
        d="M52.5248 0.578966C53.6865 0.5558 54.8483 0.578966 55.9983 0.567383C56.8432 3.97279 57.6059 7.38977 58.4391 10.7952C58.1105 10.355 57.6763 10.0075 57.2773 9.61371C55.7401 8.14267 54.2028 6.68321 52.6773 5.22375C51.5038 6.67163 50.4125 8.189 49.2742 9.66004C47.5609 11.9071 45.8594 14.1658 44.1579 16.4245C43.888 16.772 43.6063 17.1195 43.3834 17.5017C44.5451 17.5481 45.7069 17.5017 46.8569 17.5249C47.2089 17.5249 47.5844 17.5712 47.8895 17.3627C47.8661 17.4207 47.8191 17.5249 47.7956 17.5712C46.0706 17.5712 44.3456 17.5828 42.6206 17.5597C42.914 16.9226 43.1956 16.2739 43.5124 15.6485C43.6298 15.5442 43.7589 15.44 43.8293 15.301C46.1176 10.9226 48.4411 6.5558 50.7411 2.189C50.9288 1.84151 51.0814 1.47086 51.3395 1.1697C51.6564 0.833792 52.114 0.729545 52.5248 0.578966Z"
        fill="#3C58BF"
      />
      <path
        d="M18.9866 0.682882C20.3947 0.671299 21.8029 0.682882 23.2111 0.682882C21.4039 4.70219 19.5616 8.69833 17.7427 12.7176C17.5549 13.1115 17.3906 13.5284 17.1794 13.9107C17.3085 13.2041 17.7075 12.5786 17.9539 11.8952C16.9565 10.8644 15.9121 9.85663 14.8794 8.84891C15.0437 8.68674 15.1728 8.48983 15.2666 8.26976C16.4753 5.73308 17.7662 3.23115 18.9866 0.682882Z"
        fill="#3C58BF"
      />
      <path
        d="M6.13721 3.02344L6.28976 3.1161C7.60406 7.67981 8.90662 12.2435 10.2092 16.8188C10.3031 17.0505 10.2913 17.34 10.4908 17.5138C12.1806 17.5601 13.8822 17.5022 15.5837 17.537C15.4546 17.6875 15.2434 17.6412 15.0674 17.6528C13.4832 17.6412 11.899 17.6528 10.3148 17.6412C8.91835 12.7763 7.51018 7.89989 6.13721 3.02344Z"
        fill="#293688"
      />
      <path
        d="M30.1231 13.0879C31.4961 13.6439 32.916 14.2346 34.418 14.2694C35.6737 14.3852 37.1992 14.3157 38.0676 13.2732C37.915 13.725 37.4573 13.9682 37.0349 14.1304C36.0257 14.5242 34.8992 14.4431 33.843 14.3389C32.5991 14.2114 31.4374 13.7481 30.2991 13.2732C30.2404 13.308 30.1348 13.3775 30.0879 13.4006C30.0879 13.3311 30.1114 13.169 30.1231 13.0879Z"
        fill="#293688"
      />
      <path
        d="M17.0034 14.3051C17.0034 14.2935 17.016 14.2704 17.0287 14.2588C17.016 14.2704 17.0034 14.2935 17.0034 14.3051Z"
        fill="#293688"
      />
      <path
        d="M0 0.613321C2.86329 0.566989 5.73831 0.613321 8.6016 0.590155C9.25875 0.578572 10.0098 0.636487 10.5026 1.12297C10.9251 1.5168 11.0072 2.11911 11.1246 2.65193C11.2537 3.30058 11.4297 3.93764 11.5236 4.59788C11.2419 4.27355 11.2419 3.81023 11.1363 3.41641C11.0072 2.84884 10.7256 2.30444 10.2679 1.93378C9.86896 1.62104 9.35263 1.48205 8.85977 1.4473C6.7123 1.25039 4.56483 1.01873 2.40563 0.833398C1.77195 0.775483 1.15001 0.636487 0.528066 0.740734C0.340309 0.740734 0.176022 0.659653 0 0.613321Z"
        fill="#FFBC00"
      />
      <path
        d="M25.0066 0.637017C25.253 0.53277 25.5816 0.613851 25.8515 0.579102C24.8775 4.91115 23.8448 9.23161 22.8708 13.5637C22.8239 13.5173 22.7418 13.4362 22.6948 13.4015C23.4693 9.13895 24.2203 4.88798 25.0066 0.637017Z"
        fill="#3C58BF"
      />
      <path
        d="M50.5066 0.926592C51.1051 0.555936 51.8444 0.613851 52.525 0.579102C52.1143 0.718098 51.6566 0.833928 51.3515 1.16984C51.0816 1.47099 50.9291 1.84165 50.753 2.18914C48.453 6.56752 46.1295 10.9227 43.8413 15.3011C43.7708 15.4401 43.63 15.5444 43.5244 15.6486C45.5897 11.0733 47.6903 6.5096 49.7556 1.93431C49.9199 1.54049 50.1311 1.14667 50.5066 0.926592Z"
        fill="#3C58BF"
      />
      <path
        d="M18.0245 0.695177C18.3414 0.683594 18.6582 0.683594 18.9751 0.683594C17.7664 3.23186 16.4638 5.73379 15.2434 8.28205C15.1495 8.50213 15.0204 8.69904 14.8561 8.8612L14.7153 8.69904C15.8301 6.03495 16.9449 3.37085 18.0245 0.695177Z"
        fill="#3C58BF"
      />
      <path
        d="M32.5521 2.77947C33.2093 1.98024 34.0776 1.36634 35.0282 0.960938C34.7817 1.33159 34.3475 1.49376 34.0424 1.8065C32.4582 3.20804 31.9537 5.58256 32.646 7.54009C32.869 8.2119 33.3501 8.74472 33.7725 9.28912L33.62 9.31229C32.6929 8.68681 31.8832 7.8065 31.6016 6.70611C31.273 5.33932 31.672 3.85669 32.5521 2.77947Z"
        fill="#3C58BF"
      />
      <path
        d="M0.52832 0.742078C1.15026 0.626248 1.77221 0.776827 2.39415 0.823159C4.55335 1.00849 6.70082 1.24015 8.84829 1.43706C9.35288 1.48339 9.85748 1.6108 10.2565 1.92354C10.7141 2.2942 10.9958 2.8386 11.1248 3.40617C11.2422 3.79999 11.2305 4.25173 11.5121 4.58764C11.9111 6.13976 12.181 7.73822 12.58 9.29034C12.4391 8.94285 12.2631 8.59536 12.1106 8.24787C12.0636 7.65714 11.8172 7.12432 11.6646 6.55675C11.4651 5.96602 11.3478 5.32895 11.031 4.77297C10.7376 4.24015 10.2565 3.77683 9.68146 3.56833C8.93043 3.27876 8.13247 3.10501 7.3697 2.85019C7.07633 2.74594 6.77123 2.69961 6.46613 2.65327C6.39572 2.61853 6.2549 2.54903 6.18449 2.51428C5.38652 2.24787 4.58856 1.95829 3.75539 1.84246C2.71099 1.37914 1.60792 1.10115 0.52832 0.742078Z"
        fill="#F7981D"
      />
      <path
        d="M3.75537 1.83008C4.58854 1.94591 5.38651 2.24707 6.18447 2.50189C6.18447 2.71039 6.23141 2.9073 6.29009 3.10421L6.13753 3.01155C5.37477 2.57139 4.55334 2.21232 3.75537 1.83008Z"
        fill="#ED7C00"
      />
      <path
        d="M6.46582 2.6416C6.77093 2.68793 7.07603 2.73427 7.3694 2.83851C8.13216 3.10492 8.91839 3.27867 9.68115 3.55666C10.2679 3.77674 10.7373 4.22847 11.0307 4.76129C11.3475 5.31728 11.4648 5.95434 11.6643 6.56824C11.8169 7.12423 12.0633 7.66863 12.1103 8.25936C10.796 5.91959 8.82451 3.96206 6.46582 2.6416Z"
        fill="#ED7C00"
      />
      <path
        d="M6.30175 3.10427C6.23134 2.90736 6.1844 2.71045 6.19613 2.50195C6.26654 2.5367 6.40736 2.6062 6.47777 2.64095C8.82473 3.96141 10.8079 5.91894 12.1222 8.25871C12.2748 8.6062 12.4508 8.94211 12.5916 9.30118C12.9906 10.2162 12.9084 11.2471 13.2253 12.1738C13.7299 11.027 14.1641 9.834 14.7273 8.71045L14.8681 8.87261C15.9008 9.88033 16.9452 10.8765 17.9427 11.9189C17.6962 12.5908 17.309 13.2162 17.1682 13.9344C17.133 14.0618 17.086 14.1776 17.0273 14.2819C17.0273 14.2935 17.0156 14.3166 17.0039 14.3282C16.5345 15.4054 16.0299 16.4826 15.5722 17.5714C13.8707 17.5251 12.1809 17.5946 10.4793 17.5483C10.2916 17.3745 10.2916 17.0734 10.1977 16.8533C8.90687 12.2433 7.60431 7.67956 6.30175 3.10427Z"
        fill="#3C58BF"
      />
      <path
        d="M49.2864 9.65993C50.4247 8.1773 51.516 6.67151 52.6895 5.22363C54.215 6.68309 55.7523 8.15413 57.2895 9.61359C57.6768 10.0074 58.1109 10.3549 58.4512 10.7951C58.9793 12.9379 59.4252 15.1155 60.012 17.2584V17.5827C58.4865 17.5827 56.9609 17.5827 55.4237 17.5827C55.189 16.6561 55.0599 15.7063 54.8252 14.7796L54.8017 14.7333C52.7951 14.7333 50.7884 14.7333 48.7818 14.7333L48.7583 14.7796C48.4532 15.6368 48.1716 16.5055 47.8899 17.3626C47.5848 17.5827 47.2093 17.5248 46.8573 17.5248C45.6955 17.5016 44.5338 17.548 43.3838 17.5016C43.6067 17.1194 43.9001 16.7835 44.1583 16.4244C45.8716 14.1773 47.5731 11.9186 49.2864 9.65993ZM52.443 5.82595C51.6685 7.84139 50.8823 9.85684 50.1313 11.8839C51.4339 11.8839 52.7364 11.8839 54.039 11.8839C53.7221 10.3317 53.3701 8.77962 53.018 7.23908C52.889 6.64834 52.7481 6.05761 52.7129 5.45529C52.5252 5.46688 52.5134 5.69854 52.443 5.82595Z"
        fill="#3C58BF"
      />
      <path
        d="M38.1615 12.127C38.3845 12.3007 38.6074 12.4744 38.8069 12.6829C39.8161 13.6791 40.8605 14.6405 41.858 15.6366C41.1891 16.4243 40.2268 16.9223 39.2763 17.293C37.2814 18.0227 35.1104 18.1154 33.0217 17.8837C31.8247 17.7563 30.6395 17.4783 29.5012 17.0845C29.4895 16.8992 29.4777 16.7138 29.5247 16.5285C29.7242 15.486 29.865 14.4436 30.088 13.4011C30.1466 13.3663 30.2522 13.2968 30.2992 13.2737C31.4375 13.7486 32.5992 14.2119 33.8431 14.3393C34.8992 14.4436 36.0258 14.5246 37.035 14.1308C37.4574 13.9687 37.9151 13.7254 38.0676 13.2737C38.2436 12.9146 38.2202 12.5092 38.1615 12.127Z"
        fill="#3C58BF"
      />
      <path
        d="M22.6954 13.4014C22.7423 13.4477 22.8245 13.5288 22.8714 13.5635C24.0449 14.7334 25.1949 15.9149 26.3684 17.0848C26.4975 17.2122 26.6148 17.3628 26.7204 17.5018C25.1128 17.5712 23.5168 17.4902 21.9092 17.5481C22.2025 16.1697 22.402 14.7682 22.6954 13.4014Z"
        fill="#3C58BF"
      />
      <path
        opacity="0.3"
        d="M48.7818 14.7334C50.7884 14.7334 52.7951 14.7334 54.8017 14.7334L54.8252 14.7797C52.8068 14.7797 50.7884 14.7797 48.77 14.7797L48.7818 14.7334Z"
        fill="#1D2B67"
      />
    </svg>
  );
}

function NewCrossIcon() {
    return (
      <svg
        width="21"
        height="22"
        viewBox="0 0 21 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4932 21.2358C16.2474 21.2358 20.9121 16.5711 20.9121 10.8169C20.9121 5.06267 16.2474 0.397949 10.4932 0.397949C4.73894 0.397949 0.0742188 5.06267 0.0742188 10.8169C0.0742188 16.5711 4.73894 21.2358 10.4932 21.2358Z"
          fill="#F1F2F6"
        />
        <path
          d="M10.4984 9.77743L12.7454 7.53042C12.8454 7.43042 12.9454 7.33043 13.0454 7.23043C13.1118 7.15482 13.1931 7.0937 13.2842 7.05093C13.3753 7.00815 13.4743 6.98465 13.5749 6.98184C13.6755 6.97902 13.7756 6.99696 13.8689 7.03457C13.9623 7.07218 14.0469 7.12869 14.1174 7.20046C14.1882 7.27187 14.2435 7.35708 14.2799 7.45077C14.3163 7.54446 14.3331 7.64463 14.3291 7.74508C14.3252 7.84553 14.3006 7.94408 14.257 8.03463C14.2133 8.12519 14.1515 8.2058 14.0754 8.27145C14.0234 8.32545 13.9754 8.37647 13.9184 8.42947C13.1704 9.17747 12.422 9.92475 11.6734 10.6714C11.6219 10.7151 11.5671 10.7546 11.5094 10.7895C11.5824 10.8675 11.6224 10.9134 11.6654 10.9564C12.4654 11.7564 13.2654 12.5565 14.0654 13.3565C14.1497 13.426 14.2174 13.5135 14.2633 13.6126C14.3092 13.7118 14.3323 13.82 14.3307 13.9293C14.3292 14.0385 14.3031 14.1461 14.2544 14.2439C14.2057 14.3417 14.1357 14.4274 14.0494 14.4945C13.924 14.5965 13.7677 14.653 13.6061 14.6548C13.4445 14.6566 13.287 14.6036 13.1594 14.5044C13.0969 14.4547 13.0378 14.401 12.9824 14.3435C12.2057 13.5675 11.4297 12.7911 10.6544 12.0144C10.6064 11.9664 10.5674 11.9085 10.5134 11.8415C10.4464 11.9045 10.4004 11.9414 10.3584 11.9864C9.55837 12.7864 8.75841 13.5864 7.95841 14.3864C7.88973 14.4696 7.80349 14.5366 7.70591 14.5826C7.60832 14.6286 7.50177 14.6524 7.39389 14.6524C7.28601 14.6524 7.17947 14.6286 7.08188 14.5826C6.98429 14.5366 6.89806 14.4696 6.82938 14.3864C6.71986 14.2598 6.65836 14.0986 6.65561 13.9312C6.65287 13.7637 6.70911 13.6006 6.81443 13.4704C6.86501 13.4084 6.91908 13.3493 6.97641 13.2934C7.75241 12.5168 8.52873 11.7408 9.30539 10.9654C9.35039 10.9214 9.4054 10.8854 9.4664 10.8324C9.4074 10.7684 9.36641 10.7234 9.32541 10.6814C8.52541 9.88142 7.72539 9.08146 6.92539 8.28146C6.79153 8.17125 6.70087 8.01733 6.66941 7.84683C6.63794 7.67632 6.66769 7.50017 6.75339 7.34945C6.8031 7.26072 6.87091 7.18345 6.95243 7.12264C7.03395 7.06184 7.12738 7.01884 7.2266 6.99649C7.32581 6.97413 7.42863 6.97291 7.52836 6.99288C7.62808 7.01286 7.72244 7.05361 7.80539 7.11245C7.87393 7.16378 7.93816 7.22062 7.99741 7.28243C8.78274 8.06577 9.56741 8.84976 10.3514 9.63442C10.3944 9.68042 10.4394 9.72143 10.4984 9.77743Z"
          fill="#ADB3BC"
        />
      </svg>
    );
  }
  
  function OrderConfirmed() {
    return (
      <svg
        width="120"
        height="121"
        viewBox="0 0 120 121"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle opacity="0.1" cx="60" cy="60.5474" r="60" fill="#0076BE" />
        <circle opacity="0.1" cx="60" cy="60.5474" r="52" fill="#0076BE" />
        <circle opacity="0.1" cx="60" cy="60.5474" r="44" fill="#0076BE" />
        <circle cx="60" cy="60.5474" r="36" fill="#0076BE" />
        <g clip-path="url(#clip0_620_6598)">
          <path
            d="M78 50.9471C77.9156 51.0224 77.8218 51.0978 77.7467 51.1825C70.0459 58.886 62.345 66.599 54.6535 74.3025C54.3345 74.6227 54.3345 74.6227 54.0156 74.2931C50.1042 70.3754 46.1928 66.4577 42.2814 62.54C42.197 62.4553 42.1313 62.3329 42 62.2952C42 62.2763 42 62.2481 42 62.2293C43.0318 61.1933 44.073 60.1668 45.0954 59.1121C45.3017 58.9049 45.3955 58.8955 45.6019 59.1121C48.4065 61.9373 51.211 64.7437 54.025 67.5596C54.1282 67.6537 54.2032 67.7762 54.3158 67.9174C61.1068 61.0992 67.8416 54.328 74.5857 47.5474C75.655 48.6021 76.6962 49.6286 77.7467 50.6551C77.8312 50.7305 77.8874 50.8435 78.0094 50.8717C78 50.9 78 50.9188 78 50.9471Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_620_6598">
            <rect
              width="36"
              height="27"
              fill="white"
              transform="translate(42 47.5474)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
export {
  ArrowUpIcon,
  ArrowDownIcon,
  EditIcon,
  DeleteIcon,
  CartIcon,
  MasterCardSvg,
  VisaCardSvg,
  NewCrossIcon,
  OrderConfirmed
};
